import { ScrollArea, Text } from '@radix-ui/themes';
import clsx from 'clsx';
import { HubertButton } from 'components/HubertUI/HubertButton';
import { CircleX } from 'lucide-react';
import type { ComponentProps } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { TMatrixEvaluationConditional } from 'types/evaluation.types';
import type { TFormType, TSubFormType } from 'types/questions/form.types';
import MatrixEvaluationConditionalItemv2 from './MatrixEvaluationConditionalItemv2';

interface Props extends ComponentProps<'div'> {
  form: TFormType<TSubFormType>;
  evaluation: TMatrixEvaluationConditional[];
  onEvaluationChange: (e: TMatrixEvaluationConditional[]) => void;
}

const MatrixEvaluationConditional = ({ form, evaluation, onEvaluationChange, ...props }: Props) => {
  const { t } = useTranslation('Templates');
  const [internalEvaluation, setInternalEvaluation] = useState<TMatrixEvaluationConditional[]>(evaluation);

  useEffect(() => {
    onEvaluationChange(internalEvaluation);
  }, [internalEvaluation]);

  return (
    <div {...props} className={clsx('flex flex-col justify-between gap-4', 'py-4')}>
      <div className={clsx('flex flex-row justify-between gap-4', 'hubert-vertical-center')}>
        <HubertButton
          size="sm"
          onClick={() => {
            // const x: TMatrixEvaluationConditional = {
            //   name: EEvaluationType.Info,
            //   condition: {
            //     type: 'relative',
            //     reference: "answer",
            //     operator: EConditionalOperators.Equals,
            //     value: [0]
            //   }
            // }
            // setInternalEvaluation([
            //   ...internalEvaluation,
            //   x
            // ])
          }}
        >
          {t('evaluationConditional.addButton')}
        </HubertButton>
      </div>

      <ScrollArea type="auto" scrollbars="vertical" className={clsx('max-h-[400px]', 'min-h-[400px]', 'pr-3')}>
        {internalEvaluation.map((item, itemIndex: number) => {
          return (
            <MatrixEvaluationConditionalItemv2
              key={`slider-evaluation-conditional-item-${itemIndex}`}
              item={item}
              // @ts-ignore
              form={form}
              itemIndex={itemIndex}
              onUpdateItem={(updateField: string, value: any) => {
                console.log('onUpdateItem', updateField, value);

                if (updateField === 'condition-operator') {
                  setInternalEvaluation(
                    internalEvaluation.map((x, index) => {
                      if (index !== itemIndex) return x;
                      else {
                        return {
                          ...x,
                          condition: {
                            ...x.condition,
                            operator: value,
                          },
                        };
                      }
                    }),
                  );
                }

                if (updateField === 'condition-value') {
                  setInternalEvaluation(
                    internalEvaluation.map((x, index) => {
                      if (index !== itemIndex) return x;
                      else {
                        return {
                          ...x,
                          condition: {
                            ...x.condition,
                            value: value,
                          },
                        };
                      }
                    }),
                  );
                }

                if (updateField === 'evaluation') {
                  setInternalEvaluation(
                    internalEvaluation.map((x, index) => {
                      if (index !== itemIndex) return x;
                      else {
                        return {
                          ...x,
                          name: value.name,
                          bonus_points: value.bonus_points,
                        };
                      }
                    }),
                  );
                }
              }}
            >
              <div className={clsx('flex flex-row justify-between', 'p-2', 'w-full')}>
                <Text>{t('evaluationConditional.ifAnswer')}</Text>
                <CircleX
                  className="text-danger h-4 w-4 cursor-pointer"
                  onClick={() => {
                    setInternalEvaluation(internalEvaluation.filter((_, index) => index !== itemIndex));
                  }}
                />
              </div>
            </MatrixEvaluationConditionalItemv2>
          );
        })}
      </ScrollArea>
    </div>
  );
};

export default MatrixEvaluationConditional;
